import { createRoot } from "react-dom/client";
import { Sentry } from "./lib/sentry";
import App from "./App";
import "./index.css";

const container = document.getElementById("root")!;
const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
});
root.render(<App />);
